export default __webpack_public_path__ + "static/media/NarrateIcons.f493520b.woff2";